import { useFeatureGate } from '@statsig/react-bindings';
import { useAtomValue } from 'jotai';

import { AdditionalOptionsMenu, AdditionalOptionsMenuProps } from '../../components/AdditionalOptionsMenu';
import { telehealthMeasuresControlButtonEnabledGate } from '../../statsig/gates';
import { useChatDrawerButtonUtils } from '../chat/useChatDrawerButtonUtils';
import { visitorMeasuresAtom } from '../state';

export function VisitorAdditionalOptionsMenuWrapper({ children }: Pick<AdditionalOptionsMenuProps, 'children'>) {
  const hasUnreadMessages = useChatDrawerButtonUtils().unreadMessagesCount > 0;
  const visitorMeasures = useAtomValue(visitorMeasuresAtom);
  const { value: measuresControlButtonEnabled } = useFeatureGate(telehealthMeasuresControlButtonEnabledGate);
  const hasOutstandingMeasures = !!visitorMeasures?.length;
  const shouldShowVisualIndicator = hasUnreadMessages || (measuresControlButtonEnabled && hasOutstandingMeasures);
  return (
    <AdditionalOptionsMenu shouldShowVisualIndicator={shouldShowVisualIndicator}>{children}</AdditionalOptionsMenu>
  );
}
